import { useEffect, useState } from "react";
import { CardText, CardTitle, Input, FormGroup, Modal, ModalHeader, ModalBody } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import { getBrandScrappedData } from "../../ReduxToolkit/Reducers/brands";
import { scrappedIcons } from "../../static/brands_wholesalers_data";
import { getCamelCaseWord } from "../../static/brands_wholesalers_data";
import ProfileAllScrappedData from "./ProfileAllScrappedData";
import { useParams } from "react-router-dom";

const ProfileScrappedDataTab = ({ selectedBrand }) => {
  const { type } = useParams();
  const dispatch = useDispatch();
  const { isLoading, scrappedData } = useSelector((state) => state?.brands);
  const [selectedPlatform, setSelectedPlatform] = useState("predictions");
  const [selectedText, setSelectedText] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [selPlatformIcon, setSelPlatformIcon] = useState();

  const handleInputChange = (value) => {
    setSearchTerm(value);
  };

  useEffect(() => {
    try {
      if (selectedPlatform !== 'website' && selectedPlatform !== 'predictions') return;
      const objToSend = {
        type: type === 'brand' ? "brand" : "retailer",
        id: selectedBrand?.id,
        // platform: selectedPlatform,
      };

      if (scrappedData?.id === objToSend.id && scrappedData?.[selectedPlatform]?.texts?.length > 0) {
        return;
      }

      (async () => {
        try {
          await dispatch(getBrandScrappedData(objToSend));
        } catch (error) {
          console.error("Async function error:", error);
        }
      })();
    } catch (error) {
      console.error("Error outside async function:", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPlatform]);

  return (
    <div style={{ height: '70vh' }}>
      <div className="my-2 p-3 bg-white" style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.15)", borderRadius: "8px" }}>
        <h5 style={{ fontWeight: 500, marginBottom: "16px" }}>Details</h5>

        <div style={{ display: "flex", overflowX: "auto", gap: "12px" }}>
          {scrappedIcons?.map((item, index) => {
            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: selectedPlatform === item?.label ? '#000' : "#E4E4E4",
                  color: selectedPlatform === item?.label ? "white" : "black",
                  padding: "28px 12px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  width: "20%",
                }}
                onClick={() => {
                  setSelectedPlatform(item?.label);
                  setSelPlatformIcon(item?.icon);
                }}
              >
                <img src={item?.img} alt={item?.name} style={{ height: "50px", width: "auto" }} />
                <h5 style={{ fontWeight: 600, fontSize: "14px" }}>{item?.name}</h5>
              </div>
            );
          })}
        </div>
      </div>

      <div className="my-2 p-3 bg-white" style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.15)", borderRadius: "8px" }}>
        {selectedPlatform === "predictions" ? (
          <ProfileAllScrappedData isLoading={isLoading} allScrappedData={scrappedData[selectedPlatform] || {}} />
        ) : isLoading ? (
          <div style={{ height: "500px", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div className="spinner-border text-dark" role="status"></div>
          </div>
        ) : selectedPlatform === "website" ? (
          <>
            {scrappedData['predictions'] && Object.keys(scrappedData['predictions'])?.length > 0 ? (
              <>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div className="d-flex align-items-center gap-2">
                    <img src={selPlatformIcon} alt="icon" style={{ height: "30px" }} />
                    <h5>Website Scrapped Data</h5>
                  </div>
                  <FormGroup style={{ width: "auto" }}>
                    <Input
                      type="text"
                      value={searchTerm}
                      placeholder="Search"
                      onChange={(e) => handleInputChange(e.target.value)}
                      style={{ backgroundColor: "#E0E0E0", borderRadius: "6px" }}
                    />
                  </FormGroup>
                </div>
                {console.log(Object.values(scrappedData['predictions']).flat())}
                {Object.values(scrappedData['predictions']).flat()?.filter((data) => (data?.text || data?.match || '').toLowerCase().includes(searchTerm.toLowerCase())).map((data, index) => (
                  <div
                    key={index}
                    className="p-3 my-2"
                    style={{
                      border: searchTerm?.length > 0 ? "2px solid #508CFF" : "1px solid #D9D9D9",
                      borderRadius: "8px",
                    }}
                  >
                    <div className="d-flex gap-2 my-2">
                      <h6>{data?.type === 'image' ? 'Image' : "Text"}</h6>
                    </div>
                    <hr />
                    <div>
                      <p
                        style={{
                          color: "#000000",
                          fontWeight: 500,
                          my: 2,
                          display: "-webkit-box",
                          overflow: "hidden",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 4,
                          fontSize: { md: 15, sm: 12, xs: 12 },
                        }}
                      >
                        {data?.text || data?.match || ''}{" "}
                      </p>
                      <span
                        style={{
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                        onClick={() => {
                          setSelectedText(data?.text || data?.match);
                        }}
                      >
                        ( see more )
                      </span>
                    </div>

                    {data?.type === 'image' && <img src={data?.image} alt={data?.image} />}

                    <div className="d-flex gap-3 my-2">
                      <p className="mb-0">Source:</p>
                      <div className="d-flex align-items-center gap-2">
                        <img src={selPlatformIcon} alt="icon" style={{ height: "20px" }} />
                        <a href={data?.source} target="_blank" rel="noopener noreferrer" style={{ color: "#508CFF", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "300px", textDecoration: "none" }}>
                          {data?.source}
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="text-center my-5">
                <CardTitle tag="h4" style={{ fontSize: "28px", fontWeight: 600 }}>
                  Uh oh!
                </CardTitle>
                <CardText style={{ fontSize: "16px", color: "#999" }}>
                  {`${getCamelCaseWord(selectedPlatform)} URL not added`}
                </CardText>
                <img src='/no-data.png' alt="No data" style={{ height: "200px", objectFit: "contain" }} />
              </div>
            )}
          </>
        ) : (
          <>
            {scrappedData[selectedPlatform] && scrappedData[selectedPlatform]?.texts?.length > 0 ? (
              <>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div className="d-flex align-items-center gap-2">
                    <img src={selPlatformIcon} alt="icon" style={{ height: "30px" }} />
                    <h5>{selectedPlatform} Scrapped Data</h5>
                  </div>
                  <FormGroup style={{ width: "auto" }}>
                    <Input
                      type="text"
                      value={searchTerm}
                      placeholder="Search"
                      onChange={(e) => handleInputChange(e.target.value)}
                      style={{ backgroundColor: "#E0E0E0", borderRadius: "6px" }}
                    />
                  </FormGroup>
                </div>
                {scrappedData[selectedPlatform]?.texts?.filter((data) => data?.text.toLowerCase().includes(searchTerm.toLowerCase())).map((data, index) => (
                  <div
                    key={index}
                    className="p-3 my-2"
                    style={{
                      border: searchTerm?.length > 0 ? "2px solid #508CFF" : "1px solid #D9D9D9",
                      borderRadius: "8px",
                    }}
                  >
                    <div className="d-flex gap-2 my-2">
                      <h6>Text</h6>
                    </div>
                    <hr />
                    <div className="d-flex gap-3 my-2">
                      <p>Source:</p>
                      <div className="d-flex align-items-center gap-2">
                        <img src={selPlatformIcon} alt="icon" style={{ height: "20px" }} />
                        <a href={data?.source} target="_blank" rel="noopener noreferrer" style={{ color: "#508CFF", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", maxWidth: "300px", textDecoration: "none" }}>
                          {data?.source}
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="text-center my-5">
                <CardTitle tag="h4" style={{ fontSize: "28px", fontWeight: 600 }}>
                  Uh oh!
                </CardTitle>
                <CardText style={{ fontSize: "16px", color: "#999" }}>
                  {`${getCamelCaseWord(selectedPlatform)} URL not added`}
                </CardText>
                <img src='/no-data.png' alt="No data" style={{ height: "200px", objectFit: "contain" }} />
              </div>
            )}
          </>
        )}
      </div>
      <Modal isOpen={Boolean(selectedText)} toggle={() => setSelectedText(false)} style={{ maxWidth: "90vw" }}>
        <ModalHeader toggle={() => setSelectedText(false)}>
          <span style={{ fontSize: "24px", fontWeight: "700", textTransform: "uppercase" }}>
            All Text
          </span>
        </ModalHeader>
        <ModalBody>
          {selectedText}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ProfileScrappedDataTab;
